<template>
  <eki-panel v-bind="$attrs">
    <template slot="header">
      {{ title }}
      <eki-env-link
        class="ml-auto"
        :to="editingRoute"
      >
        <a-button class="btn-secondary h-auto">
          <span class="mr-6">
            Configure
          </span>
          <a-icon type="arrow-right" />
        </a-button>
      </eki-env-link>
    </template>

    <slot />
  </eki-panel>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'EditableSection',

  inheritAttrs: false,

  props: {
    title: {
      type: String,
      required: true
    },
    linkText: {
      type: String,
      default: 'Configure'
    },
    editingRoute: {
      type: Object,
      required: true
    }
  }
})
</script>
